/**
 * Last-activity widget (v0.9.63 #9.65) — сводка последних контактов с клиентом.
 */
import { useEffect, useState } from 'react';
import { Clock, MessageSquare, Briefcase, CheckCircle2, Loader2 } from 'lucide-react';
import { api } from '../api/client';
import { fmtTime } from '../lib/format';

interface ActItem { kind: string; when: string; label: string }

const KIND_ICON: Record<string, any> = {
  ticket_created: MessageSquare,
  ticket_message: MessageSquare,
  b24_comment: Briefcase,
  b24_task: CheckCircle2,
};

export function LastActivityWidget({ orgId }: { orgId: string }) {
  const [items, setItems] = useState<ActItem[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get<{ items: ActItem[]; total: number }>(`/api/v1/organizations/${orgId}/last-activity`)
      .then(r => setItems(r.data.items))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [orgId]);

  if (loading) return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-4 text-xs text-slate-500 flex items-center gap-2">
      <Loader2 size={12} className="animate-spin" /> Загрузка активности…
    </div>
  );
  if (!items || items.length === 0) return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-4 text-xs text-slate-500">
      Последняя активность не зафиксирована.
    </div>
  );

  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl">
      <header className="px-4 py-2 border-b border-slate-800 text-xs uppercase tracking-wider text-slate-500 flex items-center gap-2">
        <Clock size={11} className="text-blue-400" /> Последняя активность
      </header>
      <ul className="divide-y divide-slate-800">
        {items.slice(0, 5).map((it, i) => {
          const Icon = KIND_ICON[it.kind] || Clock;
          return (
            <li key={i} className="px-4 py-2 text-xs flex items-center gap-2">
              <Icon size={10} className="text-slate-500 shrink-0" />
              <span className="text-slate-300 flex-1 truncate">{it.label}</span>
              <span className="text-slate-500 shrink-0">{fmtTime(it.when)}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
